import {Component, OnInit} from '@angular/core';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {RemovePeopleFromTaskCommand} from '../../commands/task-manager.command';
import {CommandService} from '@core/services/command.service';
import {TaskManagerQuery} from '../../helpers/task-manager.query';
import {GetSelectedBoardAction} from '../../store/task-manager.action';
import {TaskManagerConfig} from '../../helpers/task-manager.config';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {UserInfo} from '@shared/models/user-info.model';
import {PlatformCommand} from '@shared/commands/command-base';
import {NoAccess, TicketManager, TicketOwner} from '../../constants/task-manager.constants';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';

@Component({
    standalone: false,
    selector: 'particle-task-role',
  templateUrl: './task-role.component.html',
  styleUrls: ['./task-role.component.scss']
})
export class TaskRoleComponent implements OnInit {
  invalidateSubject: InvalidateSubject;
  dynamicData: any;
  queryKey = 'taskRole';
  sourceKey: string;
  defaultPermission = {
    title: 'No Access',
    Description: '',
    permissionType: 0
  };
  hasPermission = false;
  contactsMetaData: any = {};
  userInfo: UserInfo;
  currentSelectedItems: any[];
  flag: boolean;
  sendNotificationButtonDisabled: boolean;
  permissions: any[];
  hasDynamicRole: boolean;
  parameters: { [key: string]: any };
  private id = 'task-role-view';
  serviceName = 'TicketRolesDynamicItemService';
  api: string;
  constructor(protected shareItemService: ShareItemService,
              protected taskManagerStore: Store<TaskManagerState>,
              protected commandService: CommandService,
              private snackBarService: SnackBarService,
              protected store: Store<TaskManagerState>,
              private taskManagerApiService: TaskManagerApiService,
              private securityStore: Store<SecurityState>,
              private dialogService: DialogService,
              private platformQueryService: PlatformQueryService) {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceKey = 'TaskRole';
  }

  ngOnInit() {
    this.hasDynamicRole = this.dynamicData.parameters?.roles?.length > 0;
    this.api = this.dynamicData.parameters?.taskApi;
    if (!this.api) {
      this.api = 'TaskManagerApi';
    }
    if (this.hasDynamicRole) {
      this.sourceKey = 'TaskDynamicRole';
    }
    console.log('[Task Role SourceKey]', this.sourceKey);
    // const config = Configuration.getSmartGridConfig(this.sourceKey);
    // config.Parameters.TASK_ID = this.dynamicData.card.id;
    // config.Parameters.SCOPE = this.dynamicData.card.scopeInt;
    this.parameters = {
      TicketId: this.dynamicData.card.id,
      Scope: this.dynamicData.card.scopeInt,
      HasDynamicRole: this.hasDynamicRole,
      HasVirtualGridConfig: true,
      Api: this.api,
      SourceType: this.sourceKey
    };
    this.securityStore.pipe(select(getUserInfo)).subscribe(state => this.userInfo = state);
    this.taskManagerApiService.getPermissions()
      .pipe(take(2))
      .subscribe(items => {
        if (items) {
          this.permissions = items;
        }
      });
  }

  openManageRoleDialog(showTaskManagerRole?: boolean) {
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'TaskMembersKey';
    model.itemId = this.dynamicData.card.id;
    const ticket = this.dynamicData.card;
    const query = this.rolesQuery(ticket);
    this.platformQueryService.executeQuery(query)
      .pipe(take(2))
      .subscribe(res => {
        const items = res.fieldValues['Items'];
        if (items) {
          const maxPermission = this.dynamicData.card.permissionLevel;
          const hasPermission = this.hasPermissions();
          if (hasPermission) {
            const rolesMetaData = {
              selectedRoles: items,
              permissions: this.filterPermissionsByMaxPermission(maxPermission),
              defaultPermission: this.defaultPermission,
              hasDynamicRole: this.hasDynamicRole,
              taskApi: this.api
            };
            this.shareItemService.showRoleSelectionDialog(model, rolesMetaData, null, true, this.invalidateTaskView.bind(this));
          } else {
            this.snackBarService.showError('You don\'t have permission to access this tool');
          }
        }
      });
  }

  private rolesQuery(ticket) {
    const query = new PlatformQuery();
    query.api = this.api;
    query.name = 'RolesQuery';
    query.fieldValues = {
      TicketId: ticket.id,
      Scope: ticket.scope
    };
    return query;
  }

  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'Edit':
          if (event.item.cells.DynamicRole?.value === 'True') {
            const assignedPermission = {
              title: event.item.cells.RoleName?.value,
              permissionType: event.item.cells.PermissionType?.value,
              isDynamicRole: true
            };
            this.openDynamicRoleDialog(true, assignedPermission);
          } else {
            this.openManageRoleDialog();
          }
          break;
        case 'Remove':
          if (event.item && event.item.cells && event.item.cells.RoleName) {
            const isDynamicRole = event.item.cells && event.item.cells?.DynamicRole && event.item.cells?.DynamicRole?.value === 'True';
            this.removeRole(event.item.cells.RoleName, isDynamicRole);
          }
          break;
      }
      return;
    }
  }

  invalidateTaskView(card?: any) {
    if (!card) {
      card = this.dynamicData.card;
    }
    this.dynamicData.taskInvalidator.next({card: card, sourceViewId: this.id});
  }

  removeRole(role: any, isDynamicRole?: boolean) {
    const ticket = this.dynamicData.card;
    const removeRoleCommand = new PlatformCommand('RemoveRoleCommand', this.api);
    removeRoleCommand.fieldValues['TicketId'] = ticket.id;
    removeRoleCommand.fieldValues['RoleName'] = role.value;
    removeRoleCommand.fieldValues['IsDynamicRole'] = isDynamicRole;
    this.commandService.executePlatformCommand(removeRoleCommand).pipe().subscribe(data => {
      // this.snackBarService.showInformation('Removed Role successfully');
      this.invalidateTaskView(this.dynamicData.card);
      this.invalidateSubject.invalidate();
    });
  }

  removeShare(userModel: string) {
    const removePeopleFromTaskCommand = new RemovePeopleFromTaskCommand(this.dynamicData.card.id, userModel);
    removePeopleFromTaskCommand.scope = this.dynamicData.card.scopeInt;
    this.commandService.executeCommand(removePeopleFromTaskCommand).subscribe(response => {
      this.invalidateSubject.invalidate();
      this.store.dispatch(new GetSelectedBoardAction(TaskManagerConfig.TaskManagerApiKey,
        TaskManagerQuery.getSelectedBoard(this.dynamicData.board.id, this.dynamicData.board.scope)));
    });
  }

  openDynamicRoleDialog(isUpdated: boolean, assignedPermission?: any) {
    const parameters = this.dynamicData.parameters;
    const ticket = this.dynamicData.card;
    const query = this.rolesQuery(ticket);
    this.platformQueryService.executeQuery(query)
      .pipe(take(2)).subscribe(response => {
      const items = response.fieldValues['Items'];
      if (items) {
        const dialogModel = DialogModel.create('Assign Role', 'AssignRoleDialogComponent', {
          text: assignedPermission ? assignedPermission.title : parameters.text,
          nodeId: parameters.nodeId,
          flowId: parameters.flowId,
          roles: parameters.roles,
          permissions: this.permissions,
          defaultPermissions: assignedPermission ?? this.defaultPermission
        }, '400px', '530px');
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
          if (res.action === 'OK' && res.data.input && res.data.input.selectedPermission) {
            const assignRoleCommand = new PlatformCommand('AssignTaskRoleCommand', this.api);
            assignRoleCommand.fieldValues['TicketId'] = ticket.id;
            assignRoleCommand.fieldValues['HasDynamicRole'] = this.hasDynamicRole;
            assignRoleCommand.fieldValues['Updated'] = isUpdated;
            if (isUpdated) {
              assignRoleCommand.fieldValues['RoleAssignmentInfo'] = [{
                RoleName: assignedPermission.title,
                Permission: assignedPermission.permissionType,
                IsDynamicRole: assignedPermission.isDynamicRole
              }];
            }
            assignRoleCommand.fieldValues['RoleAssignmentInfoList'] = [...items, res.data.input.selectedPermission];
            this.commandService.executePlatformCommand(assignRoleCommand).pipe().subscribe(data => {
              this.invalidateTaskView(this.dynamicData.card);
              this.invalidateSubject.invalidate();
            });
          }
        });
      }
    });
  }

  private filterPermissionsByMaxPermission(maxPermission) {
    return this.permissions.filter(p => p.permissionType >= maxPermission || p.permissionType === NoAccess);
  }

  private hasPermissions(): boolean {
    const {permissionLevel} = this.dynamicData.card;
    return (permissionLevel === TicketOwner || permissionLevel === TicketManager);
  }
}
